import { Reveal, MaskedLines } from "./Reveal";

export const SectionHeading = ({ number, overline, lines, description, align = "left" }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl`}>
    <Reveal>
      <p className="overline-label flex items-center gap-3" style={align === "center" ? { justifyContent: "center" } : {}}>
        {number && <span className="text-cement/70">{number}</span>}
        <span className="inline-block w-8 h-px bg-forest-mid" aria-hidden="true" />
        {overline}
      </p>
    </Reveal>
    <h2 className="h-display text-2xl sm:text-3xl lg:text-4xl mt-5 text-white">
      <MaskedLines lines={lines} />
    </h2>
    {description && (
      <Reveal delay={0.15}>
        <p className={`mt-6 text-cement text-base sm:text-lg leading-relaxed ${align === "center" ? "mx-auto" : ""} max-w-2xl`}>{description}</p>
      </Reveal>
    )}
  </div>
);
